export default "__VITE_ASSET__C59DnUS6__"